import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>People are very different; some are fired by the ‘big picture’,
                                                or overall concept, others by the
                                                detail and practical implications. You need to be aware also
                                                that some are more adventurous, or
                                                open to innovation and change, than others. These factors all
                                                make up a key element of your
                                                personality – how open to experience you are. So, think
                                                carefully about how to ‘pitch’ your idea in
                                                ways that will excite some and soothe or reassure others! (If
                                                you want to work out which ‘type’
                                                you are, get in touch with us to complete a personality
                                                questionnaire such as the Myers Briggs
                                                Type Indicator (MBTI).</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <ul className="greenbullet-list"
                                                    style={{marginTop:'0px !important'}}>
                                                    <li style={{paddingBottom:'0px !important'}}>Context and Task
                                                        (CAT) – building meaning into actions.
                                                    </li>
                                                </ul>
                                            </div>
                                            <p>Another acronym. As part of your initial, preparatory stage, you
                                                need to describe the CAT (Context
                                                and Task). This means the Context within which the people will
                                                be working, as well as the Tasks
                                                needed to achieve the outcome. If people understand only the
                                                situation (or Context), they may not
                                                fully understand what’s expected of them. Or, if they understand
                                                only what’s expected of them but
                                                without knowing why or what the final objectives are, they’re
                                                likely to think their roles are
                                                unimportant or meaningless, which can affect performance.</p>
                                            <p>The way you ‘give actions meaning’ impacts accuracy and
                                                performance. This is demonstrated in
                                                an example Richard Dawkins<a className="superscripttext "
                                                                             href="further_info.php?course=300"><sup>3</sup></a> uses,
                                                of an apprentice carpenter learning from a master craftsman.
                                                When the master builds a cabinet, he knows the purpose and
                                                result of everything he does, like
                                                measuring, matching grain, planing, oiling, etc.</p>
                                            <p>Imagine the apprentice trying to learn without understanding what
                                                the master craftsman was
                                                making. The apprentice would try to copy him and do things
                                                without understanding why, making
                                                more mistakes as a result – or even producing something quite
                                                unlike what was intended!</p>
                                            <p>If the apprentice knew what he was trying to make, he would make
                                                fewer mistakes, perhaps work
                                                out how to correct some of them himself, or at least understand
                                                that they were mistakes at all.</p>
                                            <p>As for performance, research in the field of positive
                                                psychology<a className="superscripttext "
                                                             href="further_info.php?course=300"><sup>4</sup></a> reveals
                                                that people are happier
                                                when they feel their work is ‘meaningful’. That is, they know
                                                why they’re doing it and what
                                                contribution it makes. In turn, the way people feel about their
                                                work impacts motivation, productivity
                                                and creativity.</p>
                                            <p>So, hopefully you’re convinced about the importance of
                                                preparation, in launching your idea. The
                                                next stage is how to ‘Explain’ it.</p>
                                            <div className="border_subtitle">Step 2 – Explain</div>
                                            <p>Once you’ve fully prepared, it’s time to communicate your vision
                                                to others. Here’s a diagram of
                                                what you need to do (we’ll explain each bit afterwards):</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/task_cycle_communicate.png')}
                                                    alt=""/>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}